export enum SleepingArrangement {
    AT_HOME = 0,
    STREET = 1,
    SHELTER = 2,
    OTHERS = 3,
}
